import styled from 'styled-components';

export const TimedealInfoStyle = styled.div`
  .require-info {
    text-align: center;
    font-size: 18px;
    padding: 5px 10px;
    margin: 0;
  }
`;

export const TimedealTextStyle = styled.div`
  font-size: 18px;
  font-weight: 700;
  line-height: 30px;
  text-align: center;
  margin-top: 10px;
  margin-bottom: 8px;
  color: black;
`;

export const TimedealTimeStyle = styled.div`
  display: flex;
  justify-content: center;
  gap: 6px;
  span {
    display: inline-block;
    background-color: black;
    padding: 4px 16px;
    border-radius: 4px;
    border: 1px solid white;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.32);
    font-size: 32px;
    font-weight: 700;
    line-height: 38.4px;
    text-align: center;
    color: white;
  }
`;

export const TimedealTitleStyle = styled.h1`
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.2px;
  color: #9b9b9b;
  text-align: center;
  margin-top: 8px;
`;

export const TimeDividerStyle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  .dot {
    width: 4px;
    height: 4px;
    border-radius: 1px;
    background-color: black;
  }
`;
